import { render } from "./CreateDocsAccount.vue?vue&type=template&id=bd88d86e&scoped=true"
import script from "./CreateDocsAccount.vue?vue&type=script&lang=js"
export * from "./CreateDocsAccount.vue?vue&type=script&lang=js"

import "./CreateDocsAccount.vue?vue&type=style&index=0&id=bd88d86e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd88d86e"]])

export default __exports__